<template>
  <Modal
    v-model="_value"
    width="500"
    title='HIK触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onSendDriverCardParams">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
    <Button type="primary" @click="onSendDriverCardParams">发送</Button>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'

  export default {
    name: 'hiksettriggeralarmmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        //报警行为选项
        alarm:null,
        alarmOptions: [
          {name: '右侧盲区报警', value: 23},
          {name: '生理疲劳(疲劳驾驶)', value: 60},
          {name: '接打电话报警', value: 61},
          {name: '抽烟报警', value: 62},
          {name: '分心驾驶', value: 63},
          {name: '未系安全带', value: 66},
          {name: '双手脱离方向盘', value: 73},
          {name: '单手脱离方向盘', value: 74},
          {name: '玩手机', value: 75},
          {name: '前车碰撞', value: 80},
        ],
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onSendDriverCardParams () {
        let content = 'SmartTrig:'+this.alarm+';A!!!'

        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content: content , urgent: false }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onCleanDriverCardParams(){
        this.alarm = null
      },
      visibleChange(val) {
        if(val){
          this.alarm = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
